import { createSlice } from '@reduxjs/toolkit';
import { PaginationType } from '@nxsys/types/models/Common';
import { showToast } from '@nxsys/utils/toast';
import { appIntl } from '@nxsys/helpers/Common';
import { rpnActs } from '../action';
import {
  GetEmployeeListToUpdateRPNParams,
  GetRPNListParams,
  RPN,
} from '../types';

export interface RPNState {
  rpnList: {
    loading: boolean;
    list: RPN[];
    pagination: PaginationType;
    queryParams: GetRPNListParams | null;
  };
  employeeList: {
    loading: boolean;
    list: any[];
    pagination: PaginationType;
    queryParams: GetEmployeeListToUpdateRPNParams | null;
  };
}

const initialState: RPNState = {
  rpnList: {
    loading: false,
    list: [],
    pagination: {
      current: 1,
      pageSize: 20,
      totalDocs: 0,
    },
    queryParams: null,
  },
  employeeList: {
    loading: false,
    list: [],
    pagination: {
      current: 1,
      pageSize: 20,
      totalDocs: 0,
    },
    queryParams: null,
  },
};

const rpnSlice = createSlice({
  name: 'rpn',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get RPN Records
    builder.addCase(rpnActs.getRPNList.pending, (state) => {
      state.rpnList.loading = true;
    });
    builder.addCase(rpnActs.getRPNList.fulfilled, (state, action) => {
      state.rpnList.loading = false;
      state.rpnList.list = action.payload.data;
      state.rpnList.pagination = action.payload.pagination;
      state.rpnList.queryParams = (action.payload as any).queryParams;
    });
    builder.addCase(rpnActs.getRPNList.rejected, (state, action) => {
      state.rpnList.loading = false;
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'rpn.getError' }),
      });
    });

    // Get Employee list to update RPN
    builder.addCase(rpnActs.getEmployeeListToUpdateRPN.pending, (state) => {
      state.employeeList.loading = true;
    });
    builder.addCase(
      rpnActs.getEmployeeListToUpdateRPN.fulfilled,
      (state, action) => {
        state.employeeList.loading = false;
        state.employeeList.list = action.payload.data;
        state.employeeList.pagination = action.payload.pagination;
        state.employeeList.queryParams = (action.payload as any).queryParams;
      },
    );
    builder.addCase(
      rpnActs.getEmployeeListToUpdateRPN.rejected,
      (state, action) => {
        state.employeeList.loading = false;
        showToast({
          type: 'error',
          message:
            (action.payload as any)?.response?.data?.message ||
            appIntl().formatMessage({ id: 'rpn.getError' }),
        });
      },
    );

    // Update RPN by employee ids
    builder.addCase(rpnActs.updateRPNByEmployeeIds.rejected, (_, action) => {
      console.log("🚀 ~ action:", action)
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.message ||
          appIntl().formatMessage({ id: 'rpn.update.getError' }),
      });
    });
  },
});

export const rpnReducer = rpnSlice.reducer;
export const rpnActions = {
  ...rpnSlice.actions,
  ...rpnActs,
};
